










































import { SystemSetting } from '@/shared/system-setting';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class EditSystemSettingDialog extends Vue {
    @Prop({ required: true }) private visible!: boolean;
    @Prop({ required: true }) private systemSetting!: SystemSetting;

    private isVisible: boolean = this.visible;

    @Watch('visible')
    private onVisibleChanged(visible: boolean): void {
        this.isVisible = visible;
    }

    private async onSaveAsync(): Promise<void> {
        const isValid = await this.$validator.validateAll();

        if (!isValid) {
            return;
        }

        this.$emit('ok', { ...this.systemSetting });
    }

    private onCancel(): void {
        this.$emit('cancel');
    }

}
